export default "__VITE_ASSET__vS7olaTo__"